<mat-toolbar class="nav-toolbar"
             fxLayoutAlign="center stretch"
             fxLayout="column"
             fxLayoutGap="4px">
    <div mat-button
         class="nav-logo"
         fxFlexAlign="left"
         (click)="navigateToLogin()">
        <div class="logo"
             [ngClass.lt-sm]="'logo-centered'"
             [ngStyle]="getSubscriptionLogo()">
        </div>
    </div>
</mat-toolbar>
